import { render, staticRenderFns } from "./diffCheckHole.vue?vue&type=template&id=a150ca4e&scoped=true"
import script from "./diffCheckHole.vue?vue&type=script&lang=js"
export * from "./diffCheckHole.vue?vue&type=script&lang=js"
import style0 from "./diffCheckHole.vue?vue&type=style&index=0&id=a150ca4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a150ca4e",
  null
  
)

export default component.exports